// extracted by mini-css-extract-plugin
export var reviewPaper = "Review-module--review-paper--mGw9Y";
export var reviewContainer = "Review-module--review-container--M5FS1";